
export default {
  name: 'LayoutBrowserSource',
  auth: false,
  data () {
    return {
      style: null
    }
  },
  head () {
    return {
      title: (this.$store.state.obsSourceTitle ? `${this.$store.state.obsSourceTitle} - ` : '') + 'OWN3D Web Component',
      script: [
        { src: 'https://twemoji.maxcdn.com/2/twemoji.min.js?2.3.0' }
      ]
    }
  },
  computed: {
    styling () {
      const fontFamily = this.$store.state.obsFontFamily
      const color = this.$route.query.color || '#000000'
      let styling = `.overwrite-color, .overwrite-color *:not(.ignore-color) {
        color: rgba(${this.hexToRGBA(color)}) !important;
      }`

      if (fontFamily) {
        styling += `* {
          font-family: ${fontFamily} !important;
        }`
      }

      return styling
    }
  },
  watch: {
    styling () {
      this.addStylingTag()
    }
  },
  mounted () {
    if (this.$route.query.testing || this.$route.query.preview || this.$route.query['extension-preview']) {
      document.body.style.backgroundColor = '#00ff00'
    } else if (!this.$isOBS && this.$route.params.token !== 'preview') {
      document.body.style.backgroundColor = 'black'
    } else {
      document.body.style.backgroundColor = 'transparent'
    }

    this.$store.commit('SET_OBS_FONT_FAMILY', this.$route.query['font-family'] || 'Arial')
    this.addStylingTag()
  },
  methods: {
    addStylingTag () {
      if (this.style) {
        this.style.remove()
      }

      this.style = document.createElement('style')
      this.style.appendChild(document.createTextNode(this.styling))
      document.querySelector('head').appendChild(this.style)
    },
    hexToRGBA (hex) {
      // extend the shorthand hex code (e.g. "03F") to full hex code (e.g. "0033FF")
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i

      hex = hex.replace(shorthandRegex, (m, r, g, b) => {
        return r + r + g + g + b + b
      })

      // parse the hex code
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex)

      if (!result) {
        return null
      }

      return [
        parseInt(result[4], 16),
        parseInt(result[3], 16),
        parseInt(result[2], 16),
        result[1] ? (parseInt(result[1], 16) / 255).toFixed(2) : 1
      ].join(',')
    }
  }
}
